export default "__VITE_ASSET__BPOIHeQe__"